export default {
  dashboard: "Panel",
  users: "Usuarios",
  adminActivities: "Actividades",
  adminStructures: "Estructuras",
  activities: "Actividades",
  myHouses: "Mis estructuras",
  bookings: "Reservas",
  partnersAndHosts: "Vendedores y anfitriones",
  wallet: "Cartera",
  points: "Puntos",
  settings: "Ajustes",
  helpSupport: "Ayuda y soporte",
  devices: "Gestión de dispositivos",
  devicesList: "Dispositivos",
  devicesPresets: "Plantillas de dispositivo",
  devicesCarousel: "Carrusel",
  devicesStatistics: "Estadísticas",
  readers: "Lectores",
  supportTickets: "Soporte de usuarios",
  supportTicketsList: "Tickets de partners",
  supportChats: "Chats de clientes",
  adminPayments: "Contabilidad",
  adminPaymentsEvents: "Eventos económicos",
  adminPaymentsExternal: "Pagos externos",
  adminPaymentsSettlements: "Liquidaciones",
  adminNotifications: "Notificaciones",
  adminProtocols: "Protocolos",
  adminAgentTranscripts: "Transcripciones de voz",
  adminNotificationsOpen_one: "{{count}} notificación abierta",
  adminNotificationsOpen_other: "{{count}} notificaciones abiertas",
  bookingsNew_one: "{{count}} nueva reserva",
  bookingsNew_other: "{{count}} nuevas reservas",
  completeProfile: "Complete su perfil",
  completeProfileTitle: "Perfil legal incompleto",
  completeProfileDescription:
    "Hasta que complete su perfil legal, sus actividades no pueden mostrarse a los clientes en el catálogo.",
  completeProfileLink: "Complete su perfil →",
  logout: "Cerrar sesión",
  impersonating: "Suplantando",
  stopImpersonating: "Dejar de suplantar",
  logoutWhileImpersonatingTitle: "Estás suplantando a {{name}}",
  logoutWhileImpersonatingMessage:
    "¿Quieres dejar de suplantar o cerrar sesión?",
  groups: {
    overview: "Resumen",
    management: "Gestión",
    operations: "Operaciones",
    finance: "Finanzas",
    account: "Cuenta",
  },
  theme: {
    switchToLight: "Cambiar al tema claro",
    switchToDark: "Cambiar al tema oscuro",
  },
  search: "Buscar…",
  openMenu: "Abrir menú",
  closeMenu: "Cerrar menú",
  breadcrumb: "Ruta de navegación",
} as const;
